"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const utils_1 = require("@loadsure/utils");
const errors_1 = __importStar(require("../errors"));
const joi_1 = __importDefault(require("joi"));
class User {
    constructor(id, email, name, phone) {
        this.id = id;
        this.email = email;
        this.name = name;
        this.phone = phone;
    }
    static fromObj(data) {
        var _a, _b;
        if (!data) {
            return User.empty();
        }
        const email = (_a = data.email) === null || _a === void 0 ? void 0 : _a.toLowerCase();
        const id = String((_b = data.id) !== null && _b !== void 0 ? _b : email);
        let { name } = data;
        if (!name) {
            name = utils_1.fullName(data.firstName, data.lastName) || undefined;
        }
        const { phone } = data;
        return new User(id, email, name, phone);
    }
    static empty() {
        return new User("", "");
    }
    validateMinimal(path) {
        const errors = [];
        if (!this.id) {
            errors.push(new errors_1.default(errors_1.eErrorCode.USER_ID_NOT_SET, `${path}.id`));
        }
        if (this.email) {
            const validateEmail = joi_1.default.string()
                .email()
                .required()
                .validate(this.email);
            if ("error" in validateEmail) {
                errors.push(new errors_1.default(errors_1.eErrorCode.EMAIL_INVALID, `${path}.email`));
            }
        }
        return errors;
    }
    validate(path) {
        const errors = this.validateMinimal(path);
        if (!this.email) {
            errors.push(new errors_1.default(errors_1.eErrorCode.EMAIL_NOT_SET, `${path}.email`));
        }
        return errors;
    }
    isValid() {
        return this.validate("").length === 0;
    }
    isEmpty() {
        return !this.id && !this.name && !this.email && !this.phone;
    }
}
exports.default = User;
//# sourceMappingURL=user.class.js.map